{
  "fr": {
    "whats_new": {
      "category": {
        "news": "Actualité",
        "product": "Mise à jour produit",
        "tip": "Astuce"
      },
      "category_plural": {
        "news": "Actualités",
        "product": "Mises à jour produit",
        "tip": "Astuces"
      },
      "earlier": "Plus ancien",
      "empty_description": "Les nouvelles fonctionnalités, astuces et actualités de Ziggu apparaîtront ici.",
      "empty_title": "Aucune publication pour l’instant",
      "helpful": "Utile",
      "helpful_impersonation": "Ce n'est pas possible lors d'un emprunt d'identité.",
      "helpful_mark": "Marquer comme utile",
      "helpful_marked": "Vous avez trouvé ceci utile",
      "image_open": "Ouvrir l'image {index} sur {count}",
      "load_failed_description": "Vérifiez votre connexion et réessayez.",
      "load_failed_title": "Impossible de charger les publications",
      "new": "Nouveau",
      "no_matches_description": "Aucune publication ne correspond à votre recherche ou à vos filtres. Effacez-les pour tout voir.",
      "no_matches_title": "Aucun résultat",
      "read_more": "En savoir plus",
      "retry": "Réessayer",
      "search": "Rechercher des publications…",
      "subtitle": "Nouvelles fonctionnalités, astuces et actualités de l’équipe Ziggu.",
      "title": "Quoi de neuf"
    }
  }
}
